/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_AccionAsync as AccionAsync,
  rec_Bo as Bo,
  rec_EditarNivel as EditarNivel,
  rec_EstadoError as EstadoError,
  rec_Go as Go,
  rec_JSXRuntime as JSXRuntime,
  rec_Lo as Lo,
  rec_React as React,
  rec_Ti as Ti,
  rec_api as api,
  rec_ii as ii,
} from "../../runtime/index.jsx";
export function GestionNiveles() {
  let e = Go(),
    [t, n] = (0, React.useState)(null),
    [r, i] = (0, React.useState)(``),
    [a, o] = (0, React.useState)({
      nivel: ``,
      subgrupo: ``,
    }),
    s = (0, React.useCallback)(async () => {
      i(``);
      try {
        n(
          await api(`/organigrama/niveles`, {
            sinCache: !0,
          }),
        );
      } catch (e) {
        i(e.message);
      }
    }, []);
  (0, React.useEffect)(() => {
    s();
  }, [s]);
  async function c(t, n, r) {
    try {
      (await api(t ? `/organigrama/niveles/${t}` : `/organigrama/niveles`, {
        method: t ? `PUT` : `POST`,
        body: JSON.stringify(n),
      }),
        e.ok(r),
        t ||
          o({
            nivel: ``,
            subgrupo: ``,
          }),
        await s());
    } catch (t) {
      e.error(t.message);
    }
  }
  return t ? (
    <div
      className={`mx-auto flex w-full max-w-3xl flex-col gap-4`}
      children={[
        <p
          className={`text-sm text-(--text)`}
          children={`Qué nivel tiene cada subgrupo de trabajo. En el organigrama se elige de esta lista.`}
        />,
        <div
          className={`${Bo} grid gap-2 sm:grid-cols-[10rem_1fr_auto]`}
          children={[
            <input
              aria-label={`Nivel`}
              className={`${Lo} min-h-11 uppercase`}
              placeholder={`NIVEL 11`}
              value={a.nivel}
              maxLength={40}
              onChange={(e) =>
                o((t) => ({
                  ...t,
                  nivel: e.target.value,
                }))
              }
            />,
            <input
              aria-label={`Subgrupo de trabajo`}
              className={`${Lo} min-h-11 uppercase`}
              placeholder={`Subgrupo de trabajo`}
              value={a.subgrupo}
              maxLength={80}
              onChange={(e) =>
                o((t) => ({
                  ...t,
                  subgrupo: e.target.value,
                }))
              }
            />,
            <AccionAsync
              className={`min-h-11`}
              icono={Ti}
              disabled={!a.subgrupo.trim() || !a.nivel.trim()}
              onClick={() =>
                c(
                  null,
                  {
                    ...a,
                    activo: !0,
                  },
                  `Nivel agregado`,
                )
              }
              children={`Agregar`}
            />,
          ]}
        />,
        <div
          className={`${Bo} overflow-x-auto p-0`}
          children={
            <table
              className={`w-full text-left text-sm`}
              children={[
                <thead
                  className={`border-b border-(--border) text-xs uppercase text-(--text)`}
                  children={
                    <tr
                      children={[
                        <th
                          className={`px-3 py-2 font-medium`}
                          children={`Nivel jerárquico`}
                        />,
                        <th
                          className={`px-3 py-2 font-medium`}
                          children={`Subgrupo de trabajo`}
                        />,
                        <th className={`px-3 py-2`} />,
                      ]}
                    />
                  }
                />,
                <tbody
                  children={t.map((e) => (
                    <EditarNivel key={e.id} nivel={e} onGuardar={c} />
                  ))}
                />,
              ]}
            />
          }
        />,
      ]}
    />
  ) : r ? (
    <EstadoError mensaje={r} onReintentar={s} />
  ) : (
    <div
      className={`flex justify-center py-16 text-(--text)`}
      children={(0, JSXRuntime.jsx)(ii, {
        className: `h-6 w-6 animate-spin`,
      })}
    />
  );
}
